import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import axios from 'axios';
import { Sparkles, ArrowRight } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const HomePromoBanner = () => {
  const { t } = useTranslation();
  const [banner, setBanner] = useState(null);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    (async () => {
      try {
        const res = await axios.get(`${API}/promo/active-banner`);
        if (res.data?.enabled && res.data?.coupon) setBanner(res.data.coupon);
      } catch { /* noop */ }
    })();
  }, []);

  if (!banner || dismissed) return null;

  return (
    <div
      className="relative bg-gradient-to-r from-gray-900 via-orange-900 to-amber-800 text-white overflow-hidden"
      data-testid="home-promo-banner"
    >
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top,rgba(251,191,36,0.25),transparent_70%)]" />
      <div className="container mx-auto px-4 py-3 relative">
        <div className="flex items-center justify-center gap-3 flex-wrap text-center">
          <Sparkles className="h-4 w-4 text-yellow-300 shrink-0" />
          <span className="text-sm md:text-base">
            <span className="font-bold text-yellow-300">−{banner.discount_percent}%</span>
            {' '}
            <span className="text-orange-100">{t('home.promo_banner.label')}</span>
            {' '}
            <span className="font-mono text-xs md:text-sm bg-black/40 px-2 py-0.5 rounded">{banner.code}</span>
          </span>
          <Link
            to={`/promo/${banner.code}`}
            className="inline-flex items-center gap-1 bg-orange-500 hover:bg-orange-600 text-white text-sm font-semibold px-3 py-1 rounded-full transition"
            data-testid="home-promo-cta"
          >
            {t('home.promo_banner.cta')} <ArrowRight className="h-3 w-3" />
          </Link>
          <button
            onClick={() => setDismissed(true)}
            className="text-white/60 hover:text-white text-xl leading-none ml-1"
            aria-label="Close"
            data-testid="home-promo-close"
          >
            ×
          </button>
        </div>
      </div>
    </div>
  );
};

export default HomePromoBanner;
